module.exports = __webpack_public_path__ + "img/2020-02_bloomberg.999113aa.png";